var clickRow = {

	init: function () {
		$('[data-click-row]:not(.js-click-row-done)').each(function () {
			var row = $(this);

			// click
			row.off('click').on('click', function (e) {
				location.href = row.attr('data-click-row');
				return false;
			});

			// done
			row.addClass('js-click-row-done');
		});
	}

};

$(function () {
	clickRow.init();
	site.doc.ajaxComplete(function () {
		clickRow.init();
	});
});